// import { PROXIES, ServiceUrls, GATEWAY_ADMIN, GATEWAY_TICKET, GATEWAY_TRANSACTION, GATEWAY_CONFIG, PAYMENT_GATEWAY, NOTIFICATION_GATEWAY, GATEWAY_DASHBOARD } from './../../config';
import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/wrappers/Http';
import { MatchOutcome, MarketSpecifier, Outcome , Channel, Tournament, SportEvent, Sport, Market, Category, Group, Parameters, Bonus, Receiver, NotificationName, DashboardInfo, ProviderCoupon, CustomerDashboard , IManualMarket} from '@model/interfaces';
import { Slidder } from '@model/banner-slide-dto.model';
import { TextSlideDTO } from '@model/text-slide.model';
import { BehaviorSubject, config, from } from 'rxjs';
import { isArray, isObject } from 'util';
import { HelperFunctions } from '../helper-functions';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { promise } from 'protractor';
import { ConfigService } from '../config.service';
import { GoalJackpot, GoalPackage, WinningRule, GoalType, GoalObj, GoalEvent } from 'src/app/interface/goal-config';
import { ActiveClient, DemoAccount, DemoAccountPayLoad, TopWinnerClient } from 'src/app/interface/customer-user';
import { BetTicketHistory } from '@model/bet-history.model';
import { map } from 'rxjs/operators';
import { BetTicket, BetTicketHistoryParams } from 'src/app/interface/tickets-history.model';
// import { GENERATED_TAX_PRNS, NEW_TAX_PRN } from 'src/app/sample-data/generated-prns.data';
import { DepotRetraitTax, WthExciseTax } from 'src/app/interface/tax-entity.model';
import { GeneratedPRN, TaxPaymentRequest, TaxPaymentResponse } from 'src/app/interface/tax-prn.model';
import { MobileTransaction } from '@model/transaction.model';
import { PaytusTransactionBulkActionResponse } from '@model/transaction-status.model';



@Injectable({
  providedIn: 'root'
})
export class SportServicesService {
  dataToExport: {data: Array<BetTicketHistory>, count: number} = {data: [],  count: 0};
  private _categories = {data: []};
  private _tournaments: Tournament[] = [];
  private _tournamentCounts = 0;
  private _sports: Sport[] = [];
  private _blackList: any = {data: [], count: 0};
  private _sportCounts;
  private _activeTournament: any;
  private _activeMarket: any;
  private _activeChannel: Channel;
  private _activeGroup: any;
  private _activeprovider: any;
  private _activePaymentConfig: any;
  private _sportEvents: Array<SportEvent> = [];
  private _sportEventCounts = 0;
  private _markets = {data: []};
  private _manualOddsConfigs: {data: Array<IManualMarket>, count: number} = {data: [],  count: 0};
  private  _outcomes: {data: Array<MatchOutcome>, count: number};
  private _selectedManualConfigs: any;
  private _selectedSportId: any;
  private  _specifiers: Array<MarketSpecifier> = [];
  private _activeSport: Sport;
  private _channels: Channel[] = [];
  private _assignedEventsForActiveChannel: any;
  private _unassignedEventsForActiveChannel: any;
  private _assignedMarketsForActiveChannel: Market[] = [];
  private _unassignedMarketsForActiveChannel: Market[] = [];
  private _tournamentEvents: SportEvent[] = [];
  private _tournamentEventsCount = 0;
  private _activeSportEvent: any;
  private _slidders = {count: 0, data: [] };
  public subjectItem = new BehaviorSubject('');
  public ticketRefChange = new BehaviorSubject<string>(null);
  public activeAgentChange = new BehaviorSubject<{
    lgAgentID: string,
    acc: string,
    tabIndex: number
  }>(null);
  private _eventResults = {};
  private _gameList: any = { data: [], count: 0 };
  private _packages = { data: [], count: 0 };
  private _activePackage: any = {};
  private _pageFormats: any = {data: [], count: 0};
  private _textSlides: any = {data: [], count: 0};
  private _betHistory: {data: Array<BetTicketHistory>, count: number} = {data: [],  count: 0};
  private _agentActivity: any = {data: [], count: 0};
  private _redistribution: any = {data: [], count: 0};
  private _agentTransactions: any = [];
  private _zones: Array<any> = [];
  private _kiosks: Array<any> = [];
  private _parameters: Array<Parameters> = [];
  private _bonuses: any = { data: [], count: 0 };
  private _dashboardConfigs = { data: [], count: 0 };
  private _activeDashboardConfig = { data: [], count: 0 };
  private _activeSlidder: Slidder;
  private _ticketstats = [];
  private _jackPotTckHistory = [];
  private _LeaguesStats = [];
  private _activeTax: any;
  private _clients = { data: [], count: 0 };
  private _receivers = { data: [], count: 0 };
  private _paymentHistory: any = [];
  private _providerCoupons: Array<ProviderCoupon> = [];
  private _activeClientDetails: ActiveClient;
  private _activeReceiver: Receiver;
  private _receiverEvents: Array<NotificationName> = [];
  private _paymentConfigs: Array<any> = [];
  private _receiverUnassignedEvents: Array<NotificationName> = [];
  private _partners: Array<any> = [];
  private _settlementMarkets: Array<any> = [];
  private _customerDashboardInfo: CustomerDashboard;
  private _demoAccounts: {data: Array<DemoAccount>, count: number} = {data: [], count: 0};
  transactionDetails: any = {};
  goalMarkets: any = [];
  winningRules: any = [];
  goalItems: any = [];
  goalCount = 0;
  goalRapport: any = {};
  activeGoalItem: any = {};
  private _clientPaymentAccounts = [];
  private _activeBetsetting: any;
  private _activeTextSlidder: any;
  paymentTicket: any;
  activeGameList: any;
  activeJackpot: GoalJackpot;
  activeGoalRule: WinningRule;
  activeGoalPackage: GoalPackage;
  activeGoalType: GoalType;
  paymentTicketCount: number;
  mobileTransactions: MobileTransaction[] = [];
  mobileTransactionsCount: number = 0;
  private _dashboardInfo: DashboardInfo = {
    totalAmountPaid: undefined,
    totalWinnings: undefined,
    winningAmount: undefined,
    confirmedUsers: undefined,
    activeUsers: undefined,
    enabledUsers: undefined,
    numWithdrawals: undefined,
    numDeposits: undefined,
    winningTickets: undefined,
    cashOutAmount: undefined,
    numberOfTickets: undefined,
    cashOuts: undefined,
    revenue : undefined,
    payments: undefined,
    openPayments: undefined,
    activeStores: undefined,
    activeCashiers: undefined,
    activeTerminals: undefined,
    prepaidDeposits: undefined,
    webDeposits: undefined,
    webWithdrawals: undefined,
    blockedUsers: undefined,
    disabledUsers: undefined,
    newWebUsers: undefined,
    verifiedUsers: undefined,
    totalTax: undefined,
    totalAmountDeposited: undefined,
    totalAmountWithdrawn: undefined,
    totalWinningAmount: undefined,
    suspendedUsers: undefined,
    collectionStats: [],
    topWinners: [],
    topPerformers: [],
    cashFlows: [],
    totalPendingStake: undefined,
    validStake: undefined
  };
  private _dashboardActivities = {};
  private _customerTransactions: any = { data: [], count: 0 };
  private _providers: Array<any> = [];
  private _subproviders: Array<any> = [];
  private _goalJackpots: Array<GoalJackpot> = new Array(0);
  private _goalPackages: Array<GoalPackage> = new Array(0);
  private _goalRules: Array<WinningRule> = new Array(0);
  private _goalTypes: Array<GoalType> = new Array(0);
  private _goalDistroTypes = new Array(0);
  private _goalObjs: Array<GoalObj> = new Array(0);
  private _goalEvts: Array<GoalEvent> = new Array(0);
  allTimeGeneratedPRNs: GeneratedPRN[] = [];

  // (public) getters & setters
  public get selectedManualConfig(): any {
    return this._selectedManualConfigs;
  }

  public set selectedManualConfig(value: any) {
    this._selectedManualConfigs = value;
  }

  public get getSelectedSpotId(): any {
    return this._selectedSportId;
  }

  public set setSelectedSportId(value: any) {
    this._specifiers = value;
  }
  public get getMarketSpecifiers(): Array<MarketSpecifier> {
    return this._specifiers;
  }

  public set setMarketSpecifiers(value: any) {
    this._specifiers = value;
  }
  public get getOutComes(): {data: Array<MatchOutcome>, count: number} {
    return this._outcomes;
  }
  public set setOutComes(value: any) {
      this._outcomes = value;
  }
  public get manualOddsConfigs(): any {
    return this._manualOddsConfigs;
  }
  public set setManualOddsConfigs(value: any) {
    this._manualOddsConfigs = value;
  }
  public get activeTextSlidder(): any {
    return this._activeTextSlidder;
  }
  public set activeTextSlidder(value: any) {
    this._activeTextSlidder = value;
  }
  public get settlementMarkets(): any {
    return this._activeTextSlidder;
  }
  public set settlementMarkets(value: any) {
    this._activeTextSlidder = value;
  }
  public get activeBetsetting(): any {
    return this._activeBetsetting;
  }
  public set activeBetsetting(value: any) {
    this._activeBetsetting = value;
  }
  public get clientPaymentAccounts(): any[] {
    return this._clientPaymentAccounts;
  }
  public set clientPaymentAccounts(value: any[]) {
    this._clientPaymentAccounts = value;
  }
  public get customerDashboardInfo() {
    return this._customerDashboardInfo;
  }
  public set customerDashboardInfo(value) {
    this._customerDashboardInfo = value;
  }

  public get goalEvts(): Array<GoalEvent> {
    return this._goalEvts;
  }
  public set goalEvts(value: Array<GoalEvent>) {
    this._goalEvts = value;
  }

  public get goalObjs(): Array<GoalObj> {
    return this._goalObjs;
  }
  public set goalObjs(value: Array<GoalObj>) {
    this._goalObjs = value;
  }

  public get goalJackpots(): Array<GoalJackpot> {
    return this._goalJackpots;
  }
  public set goalJackpots(value: Array<GoalJackpot>) {
    this._goalJackpots = value;
  }
  public get goalPackages(): Array<GoalPackage> {
    return this._goalPackages;
  }
  public set goalPackages(value: Array<GoalPackage>) {
    this._goalPackages = value;
  }
  public get goalRules(): Array<WinningRule> {
    return this._goalRules;
  }
  public set goalRules(value: Array<WinningRule>) {
    this._goalRules = value;
  }
  public get goalDistroTypes(): Array<any> {
    return this._goalDistroTypes;
  }
  public set goalDistroTypes(value: Array<any>) {
    this._goalDistroTypes = value;
  }
  public get goalTypes(): Array<GoalType> {
    return this._goalTypes;
  }
  public set goalTypes(value: Array<GoalType>) {
    this._goalTypes = value;
  }
  public get customerTransactions(): any {
    return this._customerTransactions;
  }
  public set customerTransactions(value: any) {
    this._customerTransactions = value;
  }
  public get dashboardActivities(): any {
    return this._dashboardActivities;
  }
  public set dashboardActivities(value: any) {
    this._dashboardActivities = value;
  }
  public get activePaymentConfig(): any {
    return this._activePaymentConfig;
  }
  public set activePaymentConfig(value: any) {
    this._activePaymentConfig = value;
  }
  public get subproviders(): Array<any> {
    return this._subproviders;
  }
  public set subproviders(value: Array<any>) {
    this._subproviders = value;
  }
  public get paymentConfigs(): Array<any> {
    return this._paymentConfigs;
  }
  public set paymentConfigs(value: Array<any>) {
    this._paymentConfigs = value;
  }
  public get providers(): any {
    return this._providers;
  }
  public set providers(value: any) {
    this._providers = value;
  }
  public get providerCoupons(): Array<ProviderCoupon> {
    return this._providerCoupons;
  }
  public set providerCoupons(value: Array<ProviderCoupon>) {
    this._providerCoupons = value;
  }
  public get blackList(): any {
    return this._blackList;
  }
  public set blackList(value: any) {
    this._blackList = value;
  }
  public get dashboardInfo() {
    return this._dashboardInfo;
  }
  public set dashboardInfo(value) {
    this._dashboardInfo = value;
  }
  public get activeprovider(): any {
    return this._activeprovider;
  }
  public set activeprovider(value: any) {
    this._activeprovider = value;
  }
  public get receiverUnassignedEvents(): Array<NotificationName> {
    return this._receiverUnassignedEvents;
  }
  public set receiverUnassignedEvents(value: Array<NotificationName>) {
    this._receiverUnassignedEvents = value;
  }
  public get receiverEvents() {
    return this._receiverEvents;
  }
  public set receiverEvents(value) {
    this._receiverEvents = value;
  }
  public get activeReceiver(): Receiver {
    return this._activeReceiver;
  }
  public set activeReceiver(value: Receiver) {
    this._activeReceiver = value;
  }
  public get activeClientDetails(): ActiveClient {
    return this._activeClientDetails;
  }
  public set activeClientDetails(value: ActiveClient) {
    this._activeClientDetails = value;
  }
  public get receivers(): any {
    return this._receivers;
  }
  public set receivers(value: any) {
    this._receivers = value;
  }
  public get paymentHistory(): any {
    return this._paymentHistory;
  }
  public set paymentHistory(value: any) {
    this._paymentHistory = value;
  }
  public get clients(): any {
    return this._clients;
  }
  public set clients(value: any) {
    this._clients = value;
  }
  public get activeTax(): any {
    return this._activeTax;
  }
  public set activeTax(value: any) {
    this._activeTax = value;
  }
  public get LeaguesStats() {
    return this._LeaguesStats;
  }
  public set LeaguesStats(value) {
    this._LeaguesStats = value;
  }
  public get ticketstats() {
    return this._ticketstats;
  }
  public set ticketstats(value) {
    this._ticketstats = value;
  }

  public get jackPotTckHistory() {
    return this._jackPotTckHistory;
  }

  public set jackPotTckHistory(value){
    this._jackPotTckHistory = value;
  }

  public get activeSlidder(): any {
    return this._activeSlidder;
  }
  public set activeSlidder(value: any) {
    this._activeSlidder = value;
  }
  public get activeDashboardConfig() {
    return this._activeDashboardConfig;
  }
  public set activeDashboardConfig(value) {
    this._activeDashboardConfig = value;
  }
  taxes: {data: WthExciseTax[], count: number} = { data: [], count: 0 };
  iTaxes: DepotRetraitTax[] = []
  public get dashboardConfigs() {
    return this._dashboardConfigs;
  }
  public set dashboardConfigs(value) {
    this._dashboardConfigs = value;
  }
  public get bonuses(): any {
    return this._bonuses;
  }
  public set bonuses(value: any) {
    this._bonuses = value;
  }
  public get parameters(): any {
    return this._parameters;
  }
  public set parameters(value: any) {
    this._parameters = value;
  }
  public get kiosks(): any {
    return this._kiosks;
  }
  public set kiosks(value: any) {
    this._kiosks = value;
  }
  public get zones(): any {
    return this._zones;
  }
  public set zones(value: any) {
    this._zones = value;
  }
  public get agentTransactions(): any {
    return this._agentTransactions;
  }
  public set agentTransactions(value: any) {
    this._agentTransactions = value;
  }
  public get redistribution(): any {
    return this._redistribution;
  }
  public set redistribution(value: any) {
    this._redistribution = value;
  }
  public get agentActivity(): any {
    return this._agentActivity;
  }
  public set agentActivity(value: any) {
    this._agentActivity = value;
  }
  public get betHistory(): any {
    return this._betHistory;
  }
  public set betHistory(value: any) {
    this._betHistory = value;
  }

  public get textSlides(): any {
    return this._textSlides;
  }
  public set textSlides(value: any) {
    this._textSlides = value;
  }

  public get pageFormats(): any {
    return this._pageFormats;
  }
  public set pageFormats(value: any) {
    this._pageFormats = value;
  }

  public get demoAccounts(){
    return this._demoAccounts;
  }

  public get activePackage(): any {
    return this._activePackage;
  }
  public set activePackage(value: any) {
    this._activePackage = value;
  }

  public get packages() {
    return this._packages;
  }
  public set packages(value) {
    this._packages = value;
  }

  public get gameList() {
    return this._gameList;
  }
  public set gameList(value) {
    this._gameList = value;
  }
  public get eventResults() {
    return this._eventResults;
  }
  public set eventResults(value) {
    this._eventResults = value;
  }
  public get slidders(): any {
    return this._slidders;
  }
  public set slidders(value: any) {
    this._slidders = value;
  }
  public get activeSportEvent(): any {
    return this._activeSportEvent;
  }
  public set activeSportEvent(value: any) {
    this._activeSportEvent = value;
  }

  public get tournamentEventsCount() {
    return this._tournamentEventsCount;
  }
  public set tournamentEventsCount(value) {
    this._tournamentEventsCount = value;
  }
  public get tournamentEvents(): SportEvent[] {
    return this._tournamentEvents;
  }
  public set tournamentEvents(value: SportEvent[]) {
    this._tournamentEvents = value;
  }

  public get unassignedMarketsForActiveChannel(): Market[] {
    return this._unassignedMarketsForActiveChannel;
  }
  public set unassignedMarketsForActiveChannel(value: Market[]) {
    this._unassignedMarketsForActiveChannel = value;
  }

  public get assignedMarketsForActiveChannel(): Market[] {
    return this._assignedMarketsForActiveChannel;
  }
  public set assignedMarketsForActiveChannel(value: Market[]) {
    this._assignedMarketsForActiveChannel = value;
  }
  private _groups = {count: 0, data: []};
  private _activeCategory: Category;

  public get activeCategory(): Category {
    return this._activeCategory;
  }
  public set activeCategory(value: Category) {
    this._activeCategory = value;
  }

  public get groups(): any {
    return this._groups;
  }
  public set groups(value: any) {
    this._groups = value;
  }

  public get unassignedEventsForActiveChannel(): any {
    return this._unassignedEventsForActiveChannel;
  }
  public set unassignedEventsForActiveChannel(value: any) {
    this._unassignedEventsForActiveChannel = value;
  }

  public get assignedEventsForActiveChannel(): any {
    return this._assignedEventsForActiveChannel;
  }
  public set assignedEventsForActiveChannel(value: any) {
    this._assignedEventsForActiveChannel = value;
  }

  public get channels(): Channel[] {
    return this._channels;
  }
  public set channels(value: Channel[]) {
    this._channels = value;
  }

  public get activeSport(): Sport {
    return this._activeSport;
  }
  public set activeSport(value: Sport) {
    this._activeSport = value;
  }

  public get sportCounts() {
    return this._sportCounts;
  }

  public set sportCounts(value) {
    this._sportCounts = value;
  }

  public get markets(): any {
    return this._markets;
  }
  public set markets(value: any) {
    this._markets = value;
  }

  public get activeGroup(): any {
    return this._activeGroup;
  }
  public set activeGroup(value: any) {
    this._activeGroup = value;
  }
  public get sportEventCounts() {
    return this._sportEventCounts;
  }
  public set sportEventCounts(value) {
    this._sportEventCounts = value;
  }
  public get sportEvents(): Array<SportEvent> {
    return this._sportEvents;
  }
  public set sportEvents(value: Array<SportEvent>) {
    this._sportEvents = value;
  }
  public get tournamentCounts() {
    return this._tournamentCounts;
  }
  public set tournamentCounts(value) {
    this._tournamentCounts = value;
  }
  public get activeChannel(): Channel {
    return this._activeChannel;
  }
  public set activeChannel(value: Channel) {
    this._activeChannel = value;
  }
  public get activeMarket(): any {
    return this._activeMarket;
  }
  public set activeMarket(value: any) {
    this._activeMarket = value;
  }
  public get activeTournament(): any {
    return this._activeTournament;
  }
  public set activeTournament(value: any) {
    this._activeTournament = value;
  }
  public get sports(): any {
    return this._sports;
  }
  public set sports(value: any) {
    this._sports = value;
  }
  public get tournaments(): Tournament[] {
    return this._tournaments;
  }
  public set tournaments(value: Tournament[]) {
    this._tournaments = value;
  }
  public get categories(): any {
    return this._categories;
  }
  public set categories(value: any) {
    this._categories = value;
  }
  public get partners(): Array<any> {
    return this._partners;
  }
  public set partners(value: Array<any>) {
    this._partners = value;
  }
  constructor(private httpService: HttpService,
              private translate: TranslateService,
              private configService: ConfigService,
              private messageServrice: MessageService) {
  }

  loadCategories(params) {
    return this.httpService.get('/categories', params).then(data => {
      this.categories = data;
    });
  }
  loadTransactionDetails(ref) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/v1/transaction/verify-ticket/${ref}`, {}).then(data => {
      if (data && isArray(data)) {

        this.transactionDetails[ref] = data;
        this.transactionDetails[ref + '_totalPotwin'] = 0;
        this.transactionDetails[ref + '_totalStake'] = 0;
        this.transactionDetails[ref + '_totalOdds'] = 0;
        this.transactionDetails[ref + '_totalEvents'] = 0;
        this.transactionDetails[ref + '_totalWinningAmount'] = 0;
        this.transactionDetails[ref + '_totalBonusAmount'] = 0;

        this.transactionDetails[ref].forEach(ticket => {
          // console.log(ticket);
          this.transactionDetails[ref + '_totalPotwin'] += ticket.pot_win;
          this.transactionDetails[ref + '_totalStake'] += ticket.amt;
          this.transactionDetails[ref + '_totalOdds'] += ticket.odds;
          this.transactionDetails[ref + '_totalEvents'] += ticket.details && isArray(ticket.details) ? ticket.details.length : 0;
          this.transactionDetails[ref + '_totalWinningAmount'] += ticket.winning_amount;
          this.transactionDetails[ref + '_totalBonusAmount'] += ticket.bonus_amount;
        });
      }
    });
  }
  getCustomerDashboard(params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ , '/agentStats/dashboard/customer', params).then(data => {
      if (data && data.hasOwnProperty('category')) {
        this.customerDashboardInfo = data;
        // console.log(' this.customerDashboardInfo ' , this.customerDashboardInfo)
      } else {
        this.messageServrice.add({severity: 'error',
        summary: this.translate.instant('error_loading', {name: 'client_dashboard'}), detail: ''});
      }
    });
  }
  getClientPaymentAccounts(params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ , '/provider-service/customer/accounts', params).then(resp => {
      if (resp  && resp.data && isArray(resp.data)) {
       this.clientPaymentAccounts = resp.data;
      } else {
        this.messageServrice.add({severity: 'error',
        summary: this.translate.instant('error_loading', {name: 'client_dashboard'}), detail: ''});
      }
    });
  }
  loadNotificationReceivers(params, loadMore = '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/notification/receivers', params).then(data => {
      if (loadMore === 'load-more') {
        this.receivers.count = this.receivers.count + params.perpage;
        this.receivers.data  = [...this.receivers.data, ...data.data];
      } else {
        this.receivers = data;
      }
    });
  }
  loadReceiverEvents(receiverID, params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/notification/${receiverID}/assignedEvents`, params).then(data => {
      if (Array.isArray(data)) {
        this.receiverEvents = data;
      }
    });
  }
  loadPaymentConfigs() {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/payment-config/configs`, {}).then(data => {
      if (data.hasOwnProperty('data') && Array.isArray(data.data)) {
        this.paymentConfigs = data.data;
      }
    });
  }
  loadClientConfigs(uid) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, `/payment-config/get-customer-config`, {uid});
  }
  editClientConfigs(params) {
    return this.httpService.Post(`${this.configService.GATEWAY_ADMIN_}/payment-config/modify-customer-config`, params);
  }
  loadClients(params, loadMore = ''): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/agent-service/customers', params).then(response => {
        if (response && response.hasOwnProperty('data')) {
          if (loadMore === 'load-more') {
            this.clients.count = this.clients.count + params.perpage;
            this.clients.data  = [...this.clients.data, ...response.data];
          } else {
            this.clients = response;
          }
        }
        resolve();
      }).catch(error => reject());
    });
  }

  loadDemoAccounts(params, loadMore = ''){
    return new Promise<boolean>((resolve, reject) => {
      this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/agent-service/demo-customers', params).then(response => {
        if (response && response.hasOwnProperty('data') && isArray(response.data)) {
          if (loadMore === 'load-more') {
            this._demoAccounts.count = this._demoAccounts.count + params.perpage;
            this._demoAccounts.data  = [...this._demoAccounts.data, ...response.data];
          } else {
            this._demoAccounts = response;
          }
        }
        resolve(true);
      }).catch(error => {
        if(loadMore.length === 0){
          this._demoAccounts = {data: [], count: 0};
        }
        console.error("" +error)
        reject(false);
      });
    });
  }

  createDemoAccount(params: DemoAccountPayLoad){
    return from(this.httpService.PostAuth(this.configService.GATEWAY_ADMIN_, '/v2/customer-service/register_demo', params)).pipe(map((response) => {
          if(response.hasOwnProperty('erc') && response.erc == '1'){
            return {
              data: response.data,
              msg: response.msg,
              erc: Number(response.erc),
            }
          }else {
            return {
              data: null,
              msg: response.msg,
              erc: Number(response.erc),
            }
          }
        }));
  }

  resetDemoAccounts(){
    this._demoAccounts = {data: [], count: 0};
  }
  loadResultsForSportEvents(eventID) {
    return new Promise<void>((resolve, reject) => {
      this.eventResults[eventID] = {result: {data: [], count: 0}};
      return this.httpService.get(`/sportEvents/${eventID}/market/results`, {}).then(data => {
          if (data && data.hasOwnProperty('data')) {
            this.eventResults[eventID].result = data;
          } else {
            this.eventResults[eventID] = {result: {data: [], count: 0}};
          }
          resolve();
        }).catch(err => {
          // console.log(err);
          reject(err);
        });
    });
  }

  loadTournamants(params): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      this.httpService.get('/tournaments', params).then(response => {
        this.tournaments = response.data;
        this.tournamentCounts = response.count;
        resolve();
      }).catch(error => reject());
    });
  }

  loadEvents(params, loadMore = ''): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      this.httpService.get(this.configService.SPORTS_CONFIGS.sportsEvents, params).then(response => {
        if (loadMore === 'load-more') {
          this.sportEventCounts = this.sportEventCounts + params.perpage;
          this.sportEvents  = [...this.sportEvents, ...response.data];
        } else {
          this.sportEvents = response.data;
          this.sportEventCounts = response.count;
        }
        resolve();
      }).catch(error => reject());
    });
  }

  searchTournaments(params: any, more = ''): Promise<any> {
    // console.log('params')
    return new Promise<void>((resolve, reject) => {
      this.httpService.get('/tournament/find', params).then(response => {
        if (more === 'load-more') {
          this.tournaments  = [...this.tournaments, ...response.data];
          this.tournamentCounts = response.count;
        } else {
          this.tournaments = response.data;
          this.tournamentCounts = response.count;
        }
        resolve();
      }).catch(error => {
        reject();
      });
    });
  }

  searchSports(params: any, more = ''): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      this.httpService.get('/sport/find', params).then(response => {
        if (!response.hasOwnProperty('data')) {
          reject();
        }
        if (more === 'load-more') {
          this.sports  = [...this.sports, ...response.data];
          this.sportCounts = response.count;
        } else {
          this.sports = response.data;
          this.sportCounts = response.count;
        }
        resolve();
      }).catch(error => {
        reject();
      });
    });
  }
  TicketSuspendedReason(params) {
    return  this.httpService.Post(this.configService.GATEWAY_ADMIN + `/v1/transaction/tickets/suspended/reason`, params);
  }
  updateTicketPayment(params) {
    return  this.httpService.Post(this.configService.GATEWAY_ADMIN + `/v1/transaction/tickets/suspended/update`, params);
  }

  loadEventsForChannel(type: string, params: any) {
    const urlText = type === 'assigned' ? 'eventsAssigned' : 'eventsunAssigned';
    return new Promise<void>((resolve, reject) => {
      this.httpService.get(`/channels/${this.activeChannel.lgCHANNELID}/${urlText}/`, params).then(response => {
        if (type === 'assigned') {
          if (params.page === 0) {
            this.assignedEventsForActiveChannel = response.data;
          } else {
            this.assignedEventsForActiveChannel.push(...response.data);
          }
        } else {
          if (params.page === 0) {
            this.unassignedEventsForActiveChannel = response.data;
          } else {
            this.unassignedEventsForActiveChannel.push(...response.data);
          }
        }
        // this.tournamentCounts = response.count;
        resolve();
      }).catch(error => {
        reject();
      });
    });
  }
  loadEventAssignedChannels(eventID) {
   return  this.httpService.get(`/sportEvents/${encodeURIComponent(eventID)}/channels`, {});
  }
  loadEventUnAssignedChannels(eventID) {
   return  this.httpService.get(`/sportEvents/${encodeURIComponent(eventID)}/channelsNotAssinged`, {});
  }
  loadMarketAssignedChannels(marketID) {
   return  this.httpService.get(`/market/${encodeURIComponent(marketID)}/channels`, {});
  }
  loadMarketUnAssignedChannels(marketID) {
   return  this.httpService.get(`/market/${encodeURIComponent(marketID)}/channelsNotAssinged`, {});
  }
  loadReceiverUnAssignedNotification(receiverID) {
    // tslint:disable-next-line: max-line-length
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/notification/${encodeURIComponent(receiverID)}/unassignedEvents`, {}).then(data => {
      if (Array.isArray(data)) {
        this.receiverUnassignedEvents = data;
      }
    });
   }
  loadMarketsForChannel(type: string, params: any) {
    return new Promise<void>((resolve, reject) => {
      let req;
      if (type === 'assigned') {
        req = this.httpService.get(`/channels/${this.activeChannel.lgCHANNELID}/markets/`, params);
      } else {
        req = this.httpService.get(`/channels/${this.activeChannel.lgCHANNELID}/otherMarkets/`, params);
      }
      req.then(response => {
        if (type === 'assigned') {
          if (params.page === 0) {
            this.assignedMarketsForActiveChannel = response.data;
          } else {
            this.assignedMarketsForActiveChannel.push(...response.data);
          }
        } else {
          if (params.page === 0) {
            this.unassignedMarketsForActiveChannel = response.data;
          } else {
            this.unassignedMarketsForActiveChannel.push(...response.data);
          }
        }
        resolve();
      }).catch(error => {
        reject();
      });
    });
  }

  filterEventMarkets(params, eventID) {
    return this.httpService.get(`/sportEvents/${encodeURIComponent(eventID)}/markets`, params);
  }
  updateMarketState(params, eventID) {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + `/admin/sportEvents/${encodeURIComponent(eventID)}/market/status`, params);
  }
  filterCategories(params, more = '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, this.configService.ServiceUrls.findCategoryByID, params).then(data => {
      if (more === 'load-more') {
        this.categories.data  = [...this.categories.data, ...data.data];
        this.categories.count = data.count;
      } else {
        this.categories = data;
      }
    });
  }
  filterJackpots(params, more = '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, this.configService.ServiceUrls.findCategoryByID, params).then(data => {
      if (more === 'load-more') {
        this.categories.data  = [...this.categories.data, ...data.data];
        this.categories.count = data.count;
      } else {
        this.categories = data;
      }
    });
  }
updateTicket(params) {
  // console.log(params);
return this.httpService.Post( this.configService.GATEWAY_ADMIN + '/v1/transaction/updateTickets', params);
}
  editSport(sportID, sportFormData: any): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/sport/' + encodeURIComponent(sportID) + '/edit', sportFormData);
  }
  editPaymentConfig(params): Promise<any> {
    let paramsMaps = '?';
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        paramsMaps += `${key}=${params[key]}&`;
      }
    }
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/payment-config/modify-payment-config' + paramsMaps, {});
  }
  editProvider(providerID, params: any): Promise<any> {
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/provider/${encodeURIComponent(providerID)}/updateProvider`, params);
  }
  editSubProvider(providerID, params: any): Promise<any> {
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/provider/${encodeURIComponent(providerID)}/updateSubProvider`, params);
  }
  editBlackList(blackListID, params: any): Promise<any> {
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/customer/blacklist/${encodeURIComponent(blackListID)}/update`, params);
    // return this.httpService.Post(`http://10.12.1.161:8580/admin/customer/blacklist/${encodeURIComponent(blackListID)}/update`, params);

  }
  editReceiver(recieverID, params: any): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/notification/' + encodeURIComponent(recieverID) + '/updateReceiver', params);
  }

  editCategory(category: any): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/category/' + encodeURIComponent(category.id) + '/edit', category);
  }

  editTournament(tournament: FormData): Promise<any> {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/tournament/' + encodeURIComponent(tournament.get('id').toString()) + '/edit', tournament);
  }

  editMarket(market: Market): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/market/' + encodeURIComponent(market.id + '') + '/update', market);
  }
  editOutcome(market, params: any): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/market/' + encodeURIComponent(market + '') + '/outcomes/update', params);
  }
  editGroup(group: Group): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/market/group/' + encodeURIComponent(group.id + '') + '/update', group);
  }
  editSportEvent(params: any): Promise<any> {
    // tslint:disable-next-line: max-line-length
    // console.log('edit sports paremeters',params)
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/sportEvents/' + encodeURIComponent(params.sport_event + '') + `/update?isTopEvent=${params.isTopEvent}&isEnabled=${params.isEnabled}&bonusEnabled=${params.bonusEnabled}&payEnabled=${params.payEnabled}`, {});
  }
  editSlidder(params: any): Promise<any> {
    // tslint:disable-next-line: max-line-length
    let gw = this.configService.PROXIES.sport_admin_services;
    // let gw = "http://10.12.1.185:9003/admin";
    return this.httpService.Post(gw + '/presentation/slider/' + encodeURIComponent(params.get('slider_id')) + `/update`, params);
  }
  editprovider(params: any): Promise<any> {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/presentation/slider/' + encodeURIComponent(params.get('slider_id')) + `/update`, params);
  }
  editTextSlide(params: TextSlideDTO): Promise<any> {
    const payload = this.buildTextSlidePayload(params);
    // tslint:disable-next-line: max-line-length
    let gw = this.configService.PROXIES.sport_admin_services;
    // let gw = "http://10.12.1.185:9003/admin";
    return this.httpService.Post(gw + '/presentation/textSlide/' + encodeURIComponent(params.id) + `/update`, payload);
  }
  editBonus(params: any): Promise<any> {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(this.configService.GATEWAY_CONFIG + '/v1/configs/bonusConfig/' + encodeURIComponent(params.id) + `/update`, params);
  }
  editBonusDetailConfig(params: any, bonsusID): Promise<any> {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(this.configService.GATEWAY_CONFIG + '/v1/configs/bonusConfig/' + encodeURIComponent(bonsusID) + `/updateDetail`, params);
  }
  editPackage(params: any): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + `/gameList/package/${params.id}/update`, params);
  }
  editDasbhoardConfig(params: any): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + `/gameList/dashboardPackage/${params.id}/update`, params);
  }
  editParameter(params: any): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_CONFIG + `/v1/configs/parameters/${params.id}/update`, params);
  }
  editTax(params: any): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + `/v1/configs/tax/${params.id}/update`, params);
  }
  addSlidder(params): Promise<any> {
    let gw = this.configService.PROXIES.sport_admin_services;
    // let gw = "http://10.12.1.185:9003/admin";
    return this.httpService.Post(gw + '/presentation/slider/add', params);
  }
  createProvider(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/provider/create', params);
  }
  createSubProvider(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/provider/subProvider/add', params);
  }
  addBlacklist(params): Promise<any> {
    return this.httpService.Post(this.configService.PROXIES.sport_admin_services + '/customer/blacklist/add', params);
  }
  addTextSlide(params: TextSlideDTO): Promise<any> {
    const payload = this.buildTextSlidePayload(params);
    let gw = this.configService.PROXIES.sport_admin_services;
    // let gw = "http://10.12.1.185:9003/admin";
    return this.httpService.Post(gw + '/presentation/textSlide/create', payload);
  }

  buildTextSlidePayload(data: TextSlideDTO): any {
    const channelIds = Array.isArray(data.channelId) ? data.channelId : [data.channelId];
    const startDate = data.startDate || 0;
    const endDate = data.endDate || 0;
    return {
      message: data.messages[data.lang] || data.message || '',
      messages: data.messages,
      lang: data.lang,
      status: String(data.status !== undefined ? data.status : true),
      isDefault: String(data.isDefault !== undefined ? data.isDefault : false),
      createdBy: data.createdBy,
      userId: data.userId,
      channelId: channelIds,
      startDate,
      endDate
    };
  }

  addPackage(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/gameList/package/create', params);
  }
  addReceiver(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/notification/createReceiver', params);
  }
  addDashboardCongig(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/gameList/dashboardPackage/create', params);
  }
  addGameList(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/gameList/create', params);
  }
  editGameList(id, params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/gameList/update/' + id, params);
  }
  addGoalJackpot(params): Promise<any> {
    return this.httpService.post_request(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.newJackpot, params, true);
  }
  addGoalType(params): Promise<any> {
    return this.httpService.post_request(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.newGoalType, params, true);
  }
  addGoalWinningRule(params): Promise<any> {
    return this.httpService.post_request(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.newWinningRule, params, true);
  }
  addGoalWinningRuleItem(params): Promise<any> {
    return this.httpService.post_request(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.newWinningRuleItem, params, true);
  }
  editJackpot(params: any): Promise<any> {
    return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateJackpot, params);
  }

  addGoalPackage(params): Promise<any> {
    // this.configService.GATEWAY_ADMIN
    return this.httpService.post_request(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.newGoalPackage, params, true);
  }

  editGoalType(params: any): Promise<any> {
    return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateGoalType, params);
  }
  editGoalWinningRule(params: any): Promise<any> {
   return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateWinningRule, params);
  }
  editGoalWinningRuleItem(params: any): Promise<any> {
   return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateWinningRuleItem, params);
  }
  editGoalPackage(params: any): Promise<any> {
    return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateGoalPackage, params);
  }

  addGoalItem(params): Promise<any> {

    return this.httpService.post_request(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.newGoalObj, params, true);
  }
  updateGoalItem(params): Promise<any> {
    return this.httpService.PutAuth(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateGoal, params);
  }

  assignEventsToGoal(params): Promise<any> {
    return this.httpService.post_request(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.assignGoalEvents, params, true);
  }
  UnassignEventsToGoal(params): Promise<any> {
    return this.httpService.post_request(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.unassignGoalEvents, params, true);
  }

  addGroup(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/admin/market/group/create', params);
  }
  addBonusConfig(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_CONFIG + '/v1/configs/bonusConfig/add', params);
  }
  addAdvancedBonusConfig(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_CONFIG + '/v1/configs/bonusConfig/addDetail', params);
  }
  addTax(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_CONFIG + '/v1/configs/tax/create', params);
  }
  loadChannels(params  = {}, more = '') {
   return  this.httpService.Hget( this.configService.GATEWAY_ADMIN_ , '/channel-service/channels/', {}).then(response => {
     if (Array.isArray(response)) {
       if (more == 'load-more') {
         this.channels = [...this.channels, ...response];
       } else {

      this.channels = response;
       }
     }
    });
  }
  addMarketToGroup(groupID, marketID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/market/group/${encodeURIComponent(groupID + '')}/addMarket?id=${marketID}`, {});
  }
  removeMarketFromGroup(groupID, marketID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/market/group/${encodeURIComponent(groupID + '')}/removeMarket?id=${marketID}`, {});
  }
  addNotificationToReceiver(receiverID, notificationID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.GATEWAY_ADMIN}/notification/${encodeURIComponent(receiverID + '')}/addEvent?event=${notificationID}`, {});
  }
  removeNotificationFromReceiver(receiverID, notificationID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.GATEWAY_ADMIN}/notification/${encodeURIComponent(receiverID + '')}/removeEvent?event=${notificationID}`, {});
  }
  addMarketToChannel(lgCHANNELID, marketID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/markets/${marketID}/channel/assign/${lgCHANNELID}/fr`, {});
  }
  addChannelToSportEvent(eventID, lgCHANNELID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/sportevent/${eventID}/channel/assign/${lgCHANNELID}/fr`, {});
  }
  addChannelToMarket(marketID, lgCHANNELID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/markets/${marketID}/channel/assign/${lgCHANNELID}/fr`, {});
  }
  removeMarketFromChannel(lgCHANNELID, marketID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/markets/${marketID}/channel/unassign/${lgCHANNELID}/fr`, {});
  }
  removeChannelFromSportEvent(eventID, lgCHANNELID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/sportevent/${eventID}/channel/unassign/${lgCHANNELID}/fr`, {});
  }
  removeChannelFromMarket(marketID, lgCHANNELID) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.PROXIES.sport_admin_services}/markets/${marketID}/channel/unassign/${lgCHANNELID}/fr`, {});
  }
  removeMarketFromPackage(packageID, params) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.GATEWAY_ADMIN}/gameList/package/${encodeURIComponent(packageID)}/removeMarket`, params);
  }
  addMarketToPackage(packageID, params) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.GATEWAY_ADMIN}/gameList/package/${encodeURIComponent(packageID)}/assignMarket`, params);
  }
  removeMarketFromDashboardConfig(dashboardID, params) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.GATEWAY_ADMIN}/gameList/dashboardPackage/${encodeURIComponent(dashboardID)}/removeMarket`, params);
  }
  addMarketToDashboardConfig(dashboardID, params) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Post(`${this.configService.GATEWAY_ADMIN}/gameList/dashboardPackage/${encodeURIComponent(dashboardID)}/assignMarket`, params);
  }

  eventToChannel(event: SportEvent, type: string): Promise<any> {
    const url = this.configService.PROXIES.sport_admin_services + `/sportevent/${event.id}/channel/${type}/${this.activeChannel.lgCHANNELID}/en`;
    return this.httpService.Post(url, {});
  }

  loadMarkets(params, loadMore = '') {
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, this.configService.ServiceUrls.getAllMarkets, params ? params : {}).then(data => {
      if (loadMore === 'load-more') {
        this.markets.count = this.markets.count + params.hasOwnProperty('perpage') ? params.perpage : 0;
        this.markets.data  = [...this.markets.data, ...data.data];
      } else {
        this.markets = data;
      }
    }).catch(err => {
      console.log(err);
    });
  }

  loadManualOddsConfigs(params, loadMore = '') {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN_ , '/admin/market/manual',  params ? params : {}).then(data => {
      if (loadMore === 'load-more') {
        this._manualOddsConfigs.count = this.markets.count + params.hasOwnProperty('perpage') ? params.perpage : 0;
        this._manualOddsConfigs.data  = [...this.markets.data, ...data.data];
      } else {
        this._manualOddsConfigs = data;
      }
    }).catch(err => {
    });
  }
  createManualOddsConfiguration(params): Promise<any> {
    return this.httpService.Post(this.configService.GATEWAY_ADMIN + '/admin/market/manual?lang=en', params);
  }

  editManualOddsConfiguration(params): Promise<any> {
    return this.httpService.Put(this.configService.GATEWAY_ADMIN + '/admin/market/manual/edit?lang=en', params);
  }

  updateManualOddsConfiguration(manualMarketConfigId: String , status: string, userName: string): Promise<any> {
    const url = this.configService.PROXIES.sport_admin_services + `/market/manual?status=${status}&manualMarketId=${manualMarketConfigId}&lang=en&userName=${userName}`;

    return this.httpService.Put(url, {});
  }

  loadMarketsForSettlement(params, eventId, loadMore = '') {
    // if(this.settlementMarkets){
    //   return;
    // }
    // else{
      return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/admin/event/${eventId}/markets`, params ? params : {}).then(data => {
        // if (loadMore === 'load-more') {
        //   this.markets.count = this.markets.count + params.hasOwnProperty('perpage') ? params.perpage : 0;
        //   this.markets.data  = [...this.markets.data, ...data.data];
        // } else {
          this.settlementMarkets = data.data;
        // }
      }).catch(err => {
        console.log(err);
      });
    // }

  }
  loadCoupon(params = {}) {
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/admin/provider/getCouponTypes', params).then(data => {
      if (Array.isArray(data)) {
        this.providerCoupons = data;
      }
    }).catch(err => {
      console.log(err);
    });
  }
  loadEventDetails(eventID) {
    return  this.httpService.get(`/sportEvents/${eventID}/details`, {});
  }
  loadReceiverDetails(receiverID) {
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/notification/receivers/${receiverID}/info`, {}).then( data => {
      if (data && data.hasOwnProperty('id')) {
        this.activeReceiver = data;
      }
    });
  }
  loadTournamentDetails(tournamentID) {
    return  this.httpService.get(`/tournament/${tournamentID}`, {}).then(data => {
      if (data ) {
        this.activeTournament = data;
      }
    });
  }
  loadPackageConfigurations(params, more= '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/gameList/packages', params).then(data => {
      if (data) {
        if (more === 'load-more') {
          this.packages.data  = [...this.packages.data, ...data.data];
        }
        this.packages = data;
      }
    }).catch(err => {
      console.log(err);
    });
  }
  loadDashboardConfigurations(params, more= '') {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/gameList/dashboardPackages', params).then(data => {
      if (data) {
        if (more === 'load-more') {
          this.dashboardConfigs.data  = [...this.dashboardConfigs.data, ...data.data];
        }
        this.dashboardConfigs = data;
      }
    }).catch(err => {
      console.log(err);
    });
  }
  loadDashboardInfo(params = {}) {
    this.resetDashboardInfo();
    return this.httpService.Hget(this.configService.GATEWAY_DASHBOARD, '/admin/dashboard/info', params).then(data => {
      if (data && data.hasOwnProperty('numberOfTickets')) {
        this.dashboardInfo = data;
        // console.log("dashboard data",data);
        this.dashboardInfo.failedToLoad = false;
      } else {
        this.dashboardInfo.failedToLoad = true;
      }
    }).catch(err => {
      console.log(err);
      this.dashboardInfo.failedToLoad = true;
    });
  }
  loadDashboardActivities(params: any) {
    return this.httpService.Hget(this.configService.GATEWAY_DASHBOARD, '/agentStats/dashboard/blockStats', params).then(data => {
      if (data && data.hasOwnProperty('tickets')) {
        this.dashboardActivities[params['filter']] = data;
      } else {
        this.dashboardActivities[params['filter']] = null;
      }
    }).catch(err => {
      console.log(err);
      this.dashboardInfo.failedToLoad = true;
    });
  }
  resetDashboardInfo() {
    for (const key in this.dashboardInfo) {
      if (this.dashboardInfo.hasOwnProperty(key)) {
        this.dashboardInfo[key] = undefined;
      }
    }
    this.dashboardInfo.cashFlows = [];
    this.dashboardInfo.collectionStats = [];
    this.dashboardInfo.topWinners = [];
  }
  loadPackageDetail(packageID) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/gameList/package/${packageID}/info`, {}).then(data => {
      if (data) {
        this.activePackage = data;
      }
    }).catch(err => {
      console.log(err);
    });
  }
  loadDashboardConfigDetail(dashboardID) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/gameList/dashboardPackage/${dashboardID}/info`, {}).then(data => {
      if (data) {
        this.activeDashboardConfig = data;
      }
    }).catch(err => {
      console.log(err);
    });
  }
  loadGameList(params, more) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/gameList/listings', params).then(data => {
      if (data) {
        if (more === 'load-more') {
          this.gameList  = [...this.gameList, ...data];
          // this.gameList.count = data.count;
        } else {
            this.gameList = data;
        }
      }
    }).catch(err => {
      this.gameList = [];
    });
  }

  loadGoalJackpots(params, more) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.allJackpotConfigs, params, true).then(res => {
      if (res.hasOwnProperty('erc') && res.erc == '1') {
        this.goalJackpots = (more === 'load-more') ? [...this.goalJackpots, ...res.data] : res.data;
      }

      console.log('goal jackpots', this.goalJackpots);
    });
  }

  loadGoalDistributions(params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services,
       this.configService.GOAL_CONFIGS.goalDistributionTypes, params, true).then(res => {
        if (res.hasOwnProperty('erc') && res.erc == '1') {
          this.goalDistroTypes = res.data;
        }

        console.log('goalDistroTypes', this.goalDistroTypes);
       });
  }

  loadGoalTypes(params: any = {}) {
    params = { ...params, status: 'enable' };
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.allGoalTypes, params, true)
    .then( res => {
      if (res.hasOwnProperty('erc') && res.erc == '1') {
          this.goalTypes = res.data;
      }

          // console.log("goalTypes", this.goalTypes);
       });
  }
  getGoalType(params?: any) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services,
      this.configService.GOAL_CONFIGS.allGoalTypes, params && isObject(params) ? params : {id: params}, true);
    // return this.httpService.get_no_auth(this.configService.GATEWAY_ADMIN_  + this.configService.ServiceUrls.goal_admin_services + this.configService.GOAL_CONFIGS.allGoalTypes, params)
  }

  loadGoalWinningRules(params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services,
      this.configService.GOAL_CONFIGS.allGoalRules, params, true)
    .then((res) => {
      if (res.hasOwnProperty('erc') && res.erc == '1') {
          this.winningRules = res.data;
      }
      console.log('winning rules:', this.winningRules);

       });
    // this.configService.GATEWAY_ADMIN_  + this.configService.ServiceUrls.goal_admin_services
  }

  loadGoalWinningRuleItems(params, id?) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services,
      this.configService.GOAL_CONFIGS.winningRuleItems, params, true);
  }

  loadGoalPackages(params: any = {}) {
    params = { ...params, status: 'enable' };
    return this.httpService.Hget(
      this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services,
      this.configService.GOAL_CONFIGS.allGoalPackages, params, true);
  }

  loadTextSlides(params = {}) {
    let gw = this.configService.PROXIES.sport_admin_services;
    // let gw = "http://10.12.1.185:9003/admin";
    
    return  this.httpService.Hget(gw, '/presentation/textSlide', params).then(data => {
      if (data) {
        this.textSlides = data;
      }
    });
  }
  loadPageFormats() {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/gameList/pageFormats', {}).then(data => {
      if (data) {
        this.pageFormats.data = data.data;
      }
    });
  }
  loadParameters(params) {
    return this.httpService.Hget(this.configService.GATEWAY_CONFIG, '/v1/configs/parameters', params).then(data => {
      if (data) {
        this.parameters = data;
      }
    });
  }
  loadTaxDetail(taxID) {
    return this.httpService.Hget(this.configService.GATEWAY_CONFIG, `/v1/configs/tax/${taxID}/details`, {}).then(data => {
      if (data) {
        this.activeTax = data;
      }
    });
  }
  loadTaxes(params) {
    return this.httpService.Hget(this.configService.GATEWAY_CONFIG, '/v1/configs/taxes', params).then(data => {
      if (data) {
        this.taxes = data;
      }
    });
  }
  loadKraTaxes(params?: any) {
    return this.httpService.Hget(this.configService.GATEWAY_AGENT, '/system/configs/tax', {}).then(resp => {
      if (resp.hasOwnProperty('erc') && resp.erc == 1) {
        this.iTaxes = resp.data;
      }
    });
  }
  loadBonusConfigurations(params) {
    return this.httpService.Hget(this.configService.GATEWAY_CONFIG, '/v1/configs/bonusConfigs', params).then(data => {
      if (data) {
        this.bonuses = data;
      }
    });
  }
  loadGeneratedPRNs(params) {

    return this.httpService.Hget(this.configService.TAX_REGULATION_GATEWAY, '/api/getGeneratedPRNs', params).then(reponse => {
      if (reponse.hasOwnProperty("erc") && reponse.erc == 1) {
        this.allTimeGeneratedPRNs = reponse.data;
      }
    });
  }

  initiateTaxPayment(paymentData: TaxPaymentRequest): Promise<TaxPaymentResponse> {
    return this.httpService.Post(this.configService.TAX_REGULATION_GATEWAY + '/api/initiate-tax-payment', paymentData);
  }
  checkTaxPaymentStatus(paymentStatusData: {prn: string}) {
    return this.httpService.Hget(this.configService.TAX_REGULATION_GATEWAY, '/api/check-tax-payment-status', paymentStatusData);
  }
  requestTaxValue(params) {
    return this.httpService.Hget(this.configService.TAX_REGULATION_GATEWAY, '/api/generatePrnValue', params);
  }
  generateTaxPRN(params) {

    return this.httpService.Hget(this.configService.TAX_REGULATION_GATEWAY, '/api/generatePrnRequest', params);
  }

  loadBonusDetails(bonsuID) {
    return this.httpService.Hget(this.configService.GATEWAY_CONFIG, `/v1/configs/bonusConfig/${bonsuID}/details`, {});
  }
  loadSlidderDetails(slidderID, lang?) {
    const params = lang ? { lang } : {};
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_, `/admin/presentation/sliders/${slidderID}/details`, params).then(data => {
      if (data) {
        this.activeSlidder = data;
        return data;
      }
      return null;
    });
  }
  loadSportDetails(sportID) {
    return  this.httpService.get(`/sport/${sportID}/details`, {sportId: sportID}).then(data => {
      if (data) {
        this.activeSport = data;
      }
    });
  }
  loadCategoryDetails(categoryID) {
    return  this.httpService.get(`/category/${categoryID}`, {});
  }
  loadMarketDetials(marketID) {
    return  this.httpService.get(`/market/${marketID}`, {});
  }
  loadSlidders(params = {}) {
    return  this.httpService.get('/presentation/sliders', params).then(response => {
       this.slidders = response;
     });
   }
   loadProviders(params = {}) {
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/provider-service/getProviders', params).then(response => {
      if (response.hasOwnProperty('data') && response.data && isArray(response.data)) {
        this.providers = response.data;
      } else {
        this.messageServrice.add({severity: 'error',
        summary: this.translate.instant('error_loading', {name: this.translate.instant('providers')}), detail: ''});
      }
     });
   }
   loadsubProviders(id, params = {}) {
    //  console.log(params)
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/provider-service/' + id + '/subProviders', params).then(response => {
      if (response && isArray(response.data)) {
        this.subproviders = response.data;
      } else {
        this.messageServrice.add({severity: 'error',
        summary: this.translate.instant('error_loading', {name: this.translate.instant('sub_provider')}), detail: ''});
      }
     });
   }
   loadPartners(params = {}) {
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN_, '/partners/all', params).then(response => {
       this.partners = response;
     });
   }
   loadBlackList(params, loadMore = '') {
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/admin/customer/blacklist', params).then(data => {
      if (loadMore === 'load-more') {
        this.blackList.count = this.blackList.count + params.size;
        this.blackList.data  = [...this.blackList.data, ...data.data];
      } else {
        this.blackList = data;
      }
     });
   }
   loadTicketPayment(params) {
     return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/admin/payments/list', params).then(response => {
      if (response.hasOwnProperty('data')) {
        this.paymentTicket = response.data;
        this.paymentTicketCount = response.count;
       }
     });
   }
    loadBetHistory(params, more = '') {
    return  this.betHistoryApi(params).then((response: any) => {
       if (response.hasOwnProperty('data')) {
         if (more == 'load-more') {
           this.betHistory = [...this.betHistory, ...response];
         } else {
          this.betHistory = response;
         }
       }
     });
   }

  loadJackPotHistory(params){
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN + '/goal-transaction-service', '/transaction/history/all', params).then(response => {
      this.jackPotTckHistory = response.list || [];
      let pages = response.pages || 0;
      let count = response.count || 0;
      return { pages, count}
    });
   }

   loadJackPotHistoryDetails(id, params){
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN + '/goal-transaction-service', `/transaction/history/all/${id}`, params, true);
   }

   betHistoryApi(params) {
     return  this.httpService.Hget( this.configService.GATEWAY_ADMIN, '/v1/transaction/bet-history', params);
   }

   betTicketHistory(params: BetTicketHistoryParams): Promise<{data: BetTicket[], error: boolean}> {
      return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/v1/transaction/history', params).then((res) => {
        if(Array.isArray(res)){
          return { data: (<BetTicket[]> res), error: false};
        }else {
          return { data: (<BetTicket[]> []), error: true};
        }
      }).catch((e) => {
          console.error('Getting bet ticket history error', e);
          return { data: (<BetTicket[]> []), error: true};
      });
   }
   loadBetHistorycsv(params, more = '') {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN, '/v1/transaction/bet-history', params);
   }
  ticketsStatistics(params) {
    params.lang = this.translate.currentLang;
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/v1/transaction/getResultsByBetType', params).then(response => {
       this.ticketstats = response;
     });
   }
  LeaguesStatistics(params) {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/v1/transaction/getResultsByLeagues', params).then(response => {
       this.LeaguesStats = response;
     });
   }
  loadBetredistribution(params) {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/v1/transaction/redistribution', params).then(response => {
       if (response.hasOwnProperty('data')) {
        this.redistribution = response;
       }
     });
   }
   loadAgentActivity(params) {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/v1/transaction/agent-activity', params).then(response => {
       if (response.hasOwnProperty('data')) {
        this.agentActivity = response;
       }
     });
   }
   loadAgentTransactions(params) {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/transac-service/agent-transaction', params).then(response => {
       this.agentTransactions = response;
     });
   }
   loadCustomerTransactions(params, loadMore = '') {
    const queryParams: any = params;
    queryParams.lang = this.translate.currentLang;
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/transac-service/customer-transaction', queryParams).then(response => {
      if (response && response.hasOwnProperty('data')) {
        if (loadMore === 'load-more') {
          // this.mobileTransactionsCount = response.count;
          this.customerTransactions.data  = [...this.customerTransactions.data, ...response.data];
        } else {
          this.customerTransactions = response;
          // this.customerTransactions.count = response.count;
        }
        // this.customerTransactions = response;
      } else {
        this.messageServrice.add({severity: 'error',
        summary: this.translate.instant('error_loading', {name: 'customer_transactions'}), detail: ''});
      }
     });
   }
   getMobileTransaction(params, loadMore = '') {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/momo/transactions', params).then(response => {
      if (response && response.hasOwnProperty('data')) {
        if (loadMore === 'load-more') {
          this.mobileTransactionsCount = response.count;
          this.mobileTransactions  = [...this.mobileTransactions, ...response.data];
        } else {
          this.mobileTransactions = response.data;
          this.mobileTransactionsCount = response.count;
        }
      } else {
        this.messageServrice.add({severity: 'error',
        summary: this.translate.instant('error_loading', {name: 'customer_mobile_transactions'}), detail: ''});
      }
     });
   }
   resolveMobileTransaction(params) {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/momo/resolve', params);
   }
   reverseBulkPaytusTransactions(trxids:string[] = []):Promise<PaytusTransactionBulkActionResponse> {
    return  this.httpService.Post( this.configService.GATEWAY_ADMIN + '/paytus-reverse/bulk', trxids);
   }
   resolveMobileTransactionStatus(trxid) {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN_ , `/ser_transaction_status/${trxid}`, {});
   }
   resolvePaytusTransactionStatus(trxid) {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , `/paytus-check-status/${trxid}`, {});
   }
   resolveBulkPaytusTransactionStatus(trxids:string[] = []):Promise<PaytusTransactionBulkActionResponse> {
    return  this.httpService.Post( this.configService.GATEWAY_ADMIN + `/paytus-check-status/bulk`, trxids);
   }
   getPaymentHistory(params) {
     params.day = `${new Date(params.day).getFullYear()}-${new Date(params.day).getMonth() + 1}-${new Date(params.day).getDate()}`;
     params.day2 = `${new Date(params.day2).getFullYear()}-${new Date(params.day2).getMonth() + 1}-${new Date(params.day2).getDate()}`;
     return this.httpService.Hget(this.configService.PAYMENT_GATEWAY, '/getTransactions', params).then(response => {
       this.paymentHistory = response;
     });
  }
   loadKiosks(params = {}) {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/kiosks', params).then(response => {
       if ( response && response.hasOwnProperty('erc') && response.erc === 1) {
          this.kiosks = response.data;
          this.kiosks.unshift({id: '', name: ''});
       } else {
         this.kiosks = [];
       }
     });
   }
   loadZones() {
    return  this.httpService.Hget( this.configService.GATEWAY_ADMIN , '/zones', {}).then(response => {
      if ( response && response.hasOwnProperty('erc') && response.erc === 1) {
        this.zones = response.data;
        this.zones.unshift({id: '', name: ''});
       } else {
         this.zones = [];
       }
     });
   }
   loadGlobalTicketSuspension(params) {
     return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/', params);

   }
   loadMarketsTicketSuspension(params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/', params);

  }
  loadTicketSuspension(params) {
   return this.httpService.Hget(this.configService.GATEWAY_ADMIN, '/', params);
  }
   loadMarketSpecifiers(marketID) {
     return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/admin/market/${encodeURIComponent(marketID + '')}/specifiers`, {});
   }
   loadMarketOutcomes(marketID) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/admin/market/${encodeURIComponent(marketID + '')}/outcomes`, {});
   }

   loadGroupAssignedMarkets(groupID, params = {}) {
     return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/admin/market/group/${encodeURIComponent(groupID + '')}/assingedMarkets`, params);
   }
   loadGroupUnAssignedMarkets(groupID, params = {}) {
     return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/admin/market/group/${encodeURIComponent(groupID + '')}/unassingedMarkets`, params);
   }
   loadMarketsAssignedToPackage(packageID, params = {}) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/gameList/package/${encodeURIComponent(packageID + '')}/marketsAssigned`, params);
  }
   loadMarketsUnAssignedToPackage(packageID, params = {}) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/gameList/package/${encodeURIComponent(packageID + '')}/marketsUnAssigned`, params);
  }
   loadMarketsAssignedToDashboardConfig(dashboardID, params = {}) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/gameList/dashboardPackage/${encodeURIComponent(dashboardID + '')}/marketsAssigned`, params);
  }
   loadMarketsUnAssignedToDashboardConfig(dashboardID, params = {}) {
    // tslint:disable-next-line: max-line-length
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN, `/gameList/dashboardPackage/${encodeURIComponent(dashboardID + '')}/marketsUnAssigned`, params);
  }
  filterGroups(params, more= '') {
    return  this.httpService.Hget(this.configService.GATEWAY_ADMIN, this.configService.ServiceUrls.getGroups, params).then(data => {
      if (more === 'load-more') {
        this.groups  = [...this.groups, ...data.data];
        this.groups.count = data.count;
      } else {
      this.groups = data;
      }
    }).catch(err => {
      console.log(err);
    });
  }

  getTournamentEvents(params) {
    // return this.httpService.get(`/tournament/${this.activeTournament.id}/events`, params).then(response => {
      return this.httpService.get('/sportEvents', params).then(response => {

      this.tournamentEvents = response.data;
      this.tournamentEventsCount = response.count;
    }).catch(err => {
      console.log(err);
    });
  }

  loadGoalMarkets(params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.goalMarkets, params, true)
    .then((res) => {
      if (res.hasOwnProperty('erc') && res.erc == '1') {
          this.goalMarkets = res.data;
      }
       });
  }

  assignGoalType(params) {
    return this.httpService.post_request(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.assignGoalType, params, true);
  }

  assignWinningRule(params) {
    return  this.httpService.post_request(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.assignRule, params, true);
  }

  // assignEvents(params){
  //   return  this.httpService.Post(this.configService.GATEWAY_ADMIN + this.configService.GOAL_CONFIGS.assignEvents, params);
  // }
  assignChannels(params) {
    return  this.httpService.post_request(this.configService.GATEWAY_ADMIN + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.assignGoalChannels, params, true);
  }
  loadGoals(params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.allGoals, params, true)
    .then((res) => {
      if (res.hasOwnProperty('erc') && res.erc == '1') {
        this.goalItems = res.data;
        this.goalCount = res.count;
      } else {
        this.goalItems = [];
        this.goalCount = 0;
      }
       }).catch(err => {
        this.goalItems = [];
        this.goalCount = 0;
       });
  }

  loadGoalRapport(id) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.rapportGoal + '/' + id, {}, true)
    .then((res) => {
      if (res.hasOwnProperty('erc') && res.erc == '1') {
          this.goalRapport = res.data;
      }
       });
  }

  loadGoalEvents(params, id) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.getGoalEvents + id + '/events', params, true);
  }
    loadGoalDetails(params) {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.goalDetails, params, true);
  }

  validateGoal(params): Promise<any> {
    return this.httpService.Hget(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.validateGoal, params, true);
  }

  cancelGoal(params, id) {
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.cancelGoal + id + '/cancel', params);
  }
  confirmCancelGoal(params, id) {
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.cancelGoal + id + '/confirm-cancel', params);
  }
  reinitialiseGoal(params, id) {
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.cancelGoal + id + '/reinitialise', params);
  }
  calculateRapportGoal(params, id) {
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.calculateRapport + id, params);
  }
  distributeWinningsGoal(params, id) {
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.distributeWinnings + id, params);
  }
  settlementGoal(params) {
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.settleGoal, params);
  }
  cancelSettlementGoal(params) {
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.cancelgoalsettlement, params);
  }
  updateRapportGoal(params) {
    return  this.httpService.PutAuth(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.updateRapport, params);
  }
  reinitializeRapportGoal(id) {
    return  this.httpService.post_request(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.reinitializeRapport + '/' + id, {}, true);
  }
  confirmRapportGoal(id, params) {
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services, this.configService.GOAL_CONFIGS.confirmRapport + '/' + id, params);
  }
  rollbackCancelGoal(params, id) {
    // return  this.httpService.post_request('http://10.12.1.75:8010' + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.cancelGoal + id + '/rollback/cancel', params);
    return  this.httpService.PostAuthParams(this.configService.GATEWAY_ADMIN_ + this.configService.ServiceUrls.goal_admin_services , this.configService.GOAL_CONFIGS.cancelGoal + id + '/rollback/cancel', params);
  }
}
